import React from 'react'
import CategoryEdit from "./CategoryEdit";
import CategoryDelete from "./CategoryDelete";

const CategoryActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <CategoryEdit  category={record} updater={updater} />
            <CategoryDelete  category={record} updater={updater} />
        </React.Fragment>
    )
}
export default CategoryActions